import { Address } from 'viem';

export enum SortDestination {
  Asc = 'ASC',
  Desc = 'DESC',
}

export const PERCENT_DIVIDER = 100;

export const OPERATOR_ADDRESS = '0x0982A05D158A51A040d808ef92ccf65f2276C0B7';

export const WHITE_LIST_ADDRESS = [
  '0xBfd8194f7cC17D2f4f324E440F47571D845bcfFF',
  OPERATOR_ADDRESS,
];

export const ADMINS_LIST_ADDRESS = [
  '0xBfd8194f7cC17D2f4f324E440F47571D845bcfFF',
  OPERATOR_ADDRESS,
] as Address[];
